import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=4dc8b6c8&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8b6c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc8b6c8')) {
      api.createRecord('4dc8b6c8', component.options)
    } else {
      api.reload('4dc8b6c8', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=4dc8b6c8&scoped=true", function () {
      api.rerender('4dc8b6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/qty/components/ViewForm.vue"
export default component.exports